export const SET_INFORMATIVE_SESSIONS = "SET_INFORMATIVE_SESSIONS";
export const SET_INFORMATIVE_SESSION = "SET_INFORMATIVE_SESSION";
export const SET_PAST_SESSION = "SET_PAST_SESSION";
export const SET_REMINDER_SESSION = "SET_REMINDER_SESSION";
export const SET_SESSION_URL = "SET_SESSION_URL";
